import { useContext } from 'react'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { cleanStaticFilter, cleanShould } from '../api/talents.api'
import {
  setLastUpdatedOffers,
  setMatchingOffers,
} from '../redux/reducers/talentSlice'
import { FeathersContext } from '../services/feathers'
import { thirtyMinutes } from '../utils/constants'

function isEnabled(
  matchingOffers = [],
  lastUpdatedOffers = new Date().getTime(),
) {
  if (lastUpdatedOffers === null) {
    return true
  }
  return (
    matchingOffers.length === 0 &&
    lastUpdatedOffers + thirtyMinutes < new Date().getTime()
  )
}

export default function useGetMatchingOffers() {
  const dispatch = useDispatch()
  const feathers = useContext(FeathersContext)
  const { id, matchingOffers, lastUpdatedOffers } = useSelector(
    (state) => state.talent,
  )
  const talent = useSelector((state) => state.talent)

  const { refetch: refetchOffers, isLoading: isGettingMatchingOffers } =
    useQuery({
      queryKey: ['offers', id],
      queryFn: async () => {
        const offers = await feathers.service('lambda-talent').find({
          query: {
            type: 'getOffers',
            talentId: id,
            search: {
              should: cleanShould(talent),
              filter: cleanStaticFilter(talent),
            },
          },
        })
        dispatch(setLastUpdatedOffers())

        if (!offers.total) {
          return []
        }

        dispatch(
          setMatchingOffers(offers.data.sort((a, b) => a.score - b.score)),
        )

        return offers
      },
      refetchOnWindowFocus: false,
      retry: false,
      cacheTime: 1000 * 60 * 3,
      staleTime: 1000 * 60 * 3,
      enabled:
        process.env.NODE_ENV === 'production'
          ? isEnabled(matchingOffers, lastUpdatedOffers)
          : true,
    })

  return { refetchOffers, isGettingMatchingOffers }
}
